<template>
  <div class="container-fluid">
    <tab></tab>
    <neck ref="neck"></neck>

    <div class="hidden-xs hidden-sm">
      <div class="partner-center">
        <div class="partner-center-middle spaceBetween">
          <div class="center-middle-left">
            <img src="@/images/partnerLeft.png" alt="#" class="middle-left-img"/>
            <div class="middle-left-font">{{type==1?'认证标识':'Certification mark'}}</div>
          </div>
          <div class="center-middle-right">
            <img src="@/images/partnerRight.jpg" alt="#" class="middle-left-img"/>
            <div class="middle-left-font">{{type==1?'认证标识':'Certification mark'}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-partner-center">
        <div class="phoneCenter-middle-list">
          <img src="@/images/partnerLeft.png" alt="#" class="phoneMiddle-left-img"/>
          <div class="phoneMiddle-left-font">{{type==1?'认证标识':'Certification mark'}}</div>
        </div>
        <div class="phoneCenter-middle-list">
          <img src="@/images/partnerRight.jpg" alt="#" class="phoneMiddle-left-img"/>
          <div class="phoneMiddle-left-font">{{type==1?'认证标识':'Certification mark'}}</div>
        </div>
      </div>
    </div>

    <div class="hidden-xs hidden-sm">
      <div class="partner-middle">
        <div class="index-foot-title middle">{{type==1?'蔬适大家庭':'Vegetable suitable family'}}</div>
        <div class="partner-middle-center swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" @click="windowOpen(item.url_type,item.url,item.id)" v-for="(item,index) in pageList" :key="index">
              <div class="swiper-slide-center">
                <img :src="global.urlInfo.queryUrl+'/storage/'+item.pic_zh" alt="#" class="swiper-slide-img"/>
                <div class="slide-center-middle start">
                  <div class="center-middle-title">{{type==1?item.title_zh:item.title}}</div>
                </div>
              </div>
            </div>
            <!-- <div class="swiper-slide">
              <div class="swiper-slide-center">
                <img src="@/images/swiperImg.png" alt="#" class="swiper-slide-img"/>
                <div class="slide-center-middle">
                  <div class="center-middle-title">标题标题标题标题标题标题标题标</div>
                </div>
              </div>
            </div>

            <div class="swiper-slide">
              <div class="swiper-slide-center">
                <img src="@/images/swiperImg.png" alt="#" class="swiper-slide-img"/>
                <div class="slide-center-middle">
                  <div class="center-middle-title">标题标题标题标题标题标题标题标</div>
                </div>
              </div>
            </div>

            <div class="swiper-slide">
              <div class="swiper-slide-center">
                <img src="@/images/swiperImg.png" alt="#" class="swiper-slide-img"/>
                <div class="slide-center-middle">
                  <div class="center-middle-title">标题标题标题标题标题标题标题标</div>
                </div>
              </div>
            </div> -->
          </div>
          <img src="@/images/swiperLeft.png" alt="#" class="middle-center-img center-img-left" @click="goUp"/>
          <img src="@/images/swiperRight.png" alt="#" class="middle-center-img center-img-right" @click="goDown"/>
        </div>
      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-partner-middle">
        <div class="index-foot-titlePhone middle">{{type==1?'蔬适大家庭':'Vegetable suitable family'}}</div>

        <div class="partner-middle-centerPhone phone-swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" @click="windowOpen(item.url_type,item.url,item.id)" v-for="(item,index) in pageList" :key="index">
              <div class="swiper-slide-centerPhone">
                <img :src="global.urlInfo.queryUrl+'/storage/'+item.pic_zh" alt="#" class="swiper-slide-imgPhone"/>
                <div class="slide-center-middlePhone start">
                  <div class="center-middle-titlePhone">{{type==1?item.title_zh:item.title}}</div>
                </div>
              </div>
            </div>

            <!-- <div class="swiper-slide">
              <div class="swiper-slide-centerPhone">
                <img src="@/images/swiperImg.png" alt="#" class="swiper-slide-imgPhone"/>
                <div class="slide-center-middlePhone start">
                  <div class="center-middle-titlePhone">标题标题标题标题标题标题标题标</div>
                </div>
              </div>
            </div>

            <div class="swiper-slide">
              <div class="swiper-slide-centerPhone">
                <img src="@/images/swiperImg.png" alt="#" class="swiper-slide-imgPhone"/>
                <div class="slide-center-middlePhone start">
                  <div class="center-middle-titlePhone">标题标题标题标题标题标题标题标</div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="hidden-xs hidden-sm">
      <div class="partner-footer">
        <div class="index-foot-title middle">{{type==1?'蔬适伙伴':'Vegetable fitness partner'}}</div>
        <div class="partner-footer-center">
          <div class="footer-center-list middle" v-for="(item,index) in pageList2" :key="index">
            <img :src="global.urlInfo.queryUrl+'/storage/'+item.pic_zh" alt="#" class="center-list-img"/>
          </div>

          <!-- <div class="footer-center-list middle">
            <img src="@/images/logo1.png" alt="#" class="center-list-img"/>
          </div>

          <div class="footer-center-list middle">
            <img src="@/images/logo1.png" alt="#" class="center-list-img"/>
          </div> -->
        </div>
      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-partner-footer">
        <div class="index-foot-titlePhone middle" style="margin-bottom:0.5rem;">{{type==1?'蔬适伙伴':'Vegetable fitness partner'}}</div>

        <div class="phone-footer-center spaceBetween wrap">
          <div class="footer-center-listPhone" v-for="(item,index) in pageList2" :key="index">
            <img :src="global.urlInfo.queryUrl+'/storage/'+item.pic_zh" alt="#" class="phone-list-img"/>
          </div>

          <!-- <div class="footer-center-listPhone">
            <img src="@/images/logo1.png" alt="#" class="phone-list-img"/>
          </div>

          <div class="footer-center-listPhone">
            <img src="@/images/logo1.png" alt="#" class="phone-list-img"/>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div class="hidden-xs hidden-sm">
      <div class="web-index-foot">
        <div class="index-foot-title middle">&nbsp;</div>

        <div class="index-foot-center spaceBetween wrap">
          <div class="foot-center-li" @click="windowOpen('https://mp.weixin.qq.com/s/tZQ9Fh5FxySgJZkr8gV2bg')">
            <div class="center-li-top">
              <img src="/news/微信图片_20210910040526.png" alt="#" class="center-li-img"/>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.07.10</div>
              <div class="li-center-title fontHidden">蔬适周一中国首批10家授牌机构</div>
              <div class="li-center-font">2021年5月22日，蔬适周一中国区10家首批授牌机构在第六期“联合国粮食系统峰会·中国说”对话上，领取了具有...</div>
            </div>
          </div>

          <div class="foot-center-li" @click="windowOpen('https://mp.weixin.qq.com/s/P7uc46AryOnq8yq-ZnoH-g')">
            <div class="center-li-top">
              <img src="/news/微信图片_20210910040535.png" alt="#" class="center-li-img"/>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.07.29</div>
              <div class="li-center-title fontHidden">iDAMA颠覆你对素食餐厅的想象！| 蔬适周一认证餐厅</div>
              <div class="li-center-font">今天，小蔬适要和你介绍的这家新派素食餐厅绝对颠覆你对素食餐厅的想象...</div>
            </div>
          </div>
          
          <div class="foot-center-li" @click="windowOpen('https://mp.weixin.qq.com/s/eA-kcGUGHZTXrjCoPKlUkQ')">
            <div class="center-li-top">
              <img src="/news/微信图片_20210910040326.png" alt="#" class="center-li-img"/>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.08.12</div>
              <div class="li-center-title fontHidden">未来餐厅：晓楼 | 蔬适周一认证餐厅</div>
              <div class="li-center-font">说到未来餐厅，你眼前会浮现什么样的画面呢？在蔬小适和朋友们的眼里，云南大理古城就有一家可以定义未来餐厅的存在...</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-index-foot">

        <div class="index-foot-center spaceBetween wrap">
          <div class="foot-center-liPhone" @click="windowOpen('https://mp.weixin.qq.com/s/tZQ9Fh5FxySgJZkr8gV2bg')" >
            <div class="center-li-top">
              <img src="/news/微信图片_20210910040526.png" alt="#" class="center-li-img"/>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.07.10</div>
              <div class="li-center-title fontHidden">蔬适周一中国首批10家授牌机构</div>
              <div class="li-center-font">2021年5月22日，蔬适周一中国区10家首批授牌机构在第六期“联合国粮食系统峰会·中国说”对话上，领取了具有...</div>
            </div>
          </div>

          <div class="foot-center-liPhone" @click="windowOpen('https://mp.weixin.qq.com/s/P7uc46AryOnq8yq-ZnoH-g')" >
            <div class="center-li-top">
              <img src="/news/微信图片_20210910040535.png" alt="#" class="center-li-img"/>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.07.29</div>
              <div class="li-center-title fontHidden">iDAMA颠覆你对素食餐厅的想象！| 蔬适周一认证餐厅</div>
              <div class="li-center-font">今天，小蔬适要和你介绍的这家新派素食餐厅绝对颠覆你对素食餐厅的想象...</div>
            </div>
          </div>
          
          <div class="foot-center-liPhone" @click="windowOpen('https://mp.weixin.qq.com/s/eA-kcGUGHZTXrjCoPKlUkQ')" >
            <div class="center-li-top">
              <img src="/news/微信图片_20210910040326.png" alt="#" class="center-li-img"/>
            </div>
            <div class="center-li-center">
              <div class="li-center-label">2021.08.12</div>
              <div class="li-center-title fontHidden">未来餐厅：晓楼 | 蔬适周一认证餐厅</div>
              <div class="li-center-font">说到未来餐厅，你眼前会浮现什么样的画面呢？在蔬小适和朋友们的眼里，云南大理古城就有一家可以定义未来餐厅的存在...</div>
            </div>
          </div>
        </div>

      </div>
    </div> -->

    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab.vue'
import neck from '@/components/neck.vue'
import footerBar from '@/components/footerBar.vue'
import Swiper from 'swiper';
import axios from 'axios'
import {format} from '@/utils/util.js'
import { setTimeout } from 'timers';
export default {
  name: 'Home',
  components: {
    tab:tab,
    footerBar:footerBar,
    neck:neck
  },
  data () {
    return {
      mySwiper:null,
      mySwiperPhone:null,
      page:1,
      type:1,
      pageList:[],
      pageList2:[]
    }
  },
  methods:{
    windowOpen(url_type,url,id){
      const vm=this
      if(url_type==0){
        vm.$router.push({path: '/news',query:{id:id}});
        //window.open('/news/'+id);
      }else{
        window.open(url);
      }      
    },
    goUp(){
      const vm=this
      vm.mySwiper.slidePrev();
    },
    goDown(){
      const vm=this
      vm.mySwiper.slideNext();
    },
    queryNewsList(){
      const vm=this
      let obj = {
        category_id:5,
      }
      axios.post(`${vm.global.urlInfo.queryUrl}/api/monday/news_list`,obj).then(data=>{
        if(data&&data.data&&data.data.code==1){
          
          vm.pageList = data.data.data.data
          setTimeout(()=>{
            vm.mySwiper = new Swiper('.swiper-container', {
              slidesPerView: 3,
              spaceBetween: 10,
              centeredSlides: true,
              loop: true,
            });
            vm.mySwiperPhone = new Swiper('.phone-swiper-container');
          },400)
        }
      })
    },
    queryNewsList2(){
      const vm=this
      let obj = {
        category_id:6,
      }
      axios.post(`${vm.global.urlInfo.queryUrl}/api/monday/news_list`,obj).then(data=>{
        if(data&&data.data&&data.data.code==1){
          
          vm.pageList2 = data.data.data.data
          
        }
      })
    },
    choiceType(num){
      const vm=this
      vm.type = localStorage.getItem('ssType') || Number(num)
      vm.$refs.neck.setType(vm.type,5)
      vm.$refs.neck.setPageTips({
        site_name:'蔬适周一，舒适一周！',
        site_name_en:'Meatless Monday',
      })
      vm.$refs.footerView.setType(vm.type)
    }
  },
  created () {
    
  },
  mounted(){
    const vm=this
    vm.choiceType(1)
    vm.queryNewsList()
    vm.queryNewsList2()
  }
}
</script>
<style scoped>
/**  首页banner web  **/
.container-fluid{
  width: 100%;
  padding: 0;
  margin: 0;
}


/**  首页  新闻  **/
.web-index-foot{
  padding: 0.35rem 0.5rem 0.15rem;
  height: auto;
  background: #f5f8ef;
}
.index-foot-title{
  font-size: 0.3rem;
  color: #365b3a;
  text-align: center;
  line-height: 1;
  margin-bottom: 0.25rem;
  font-family:'huangyou';
}
.index-foot-center{
  width: 100%;
  height: auto;
}
.foot-center-li{
  width: 2.075rem;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
  margin-bottom:0.3rem
}
.center-li-top{
  width: auto;
  height: auto;
  position: relative;
}
.center-li-img{
  width: 100%;
  height: auto;
  border-radius: 8px 8px 0 0;
}
.li-top-center{
  padding: 0.0625rem 0.1rem;
  font-size: 0.1125rem;
  color: #fff;
  line-height: 1;
  background: #e4a169;
  position: absolute;
  top: 0;
  left: 0.1875rem;
  border-radius: 0 0 6px 6px;
  
}
.center-li-center{
  height: auto;
  padding: 0.125rem 0.1625rem 0.2125rem;
  background: #fff;
  border-radius: 0 0 8px 8px;
}
.li-center-label{
  font-size: 0.0935rem;
  color: #728b4a;
  line-height: 1;
  margin-bottom: 0.125rem;
  text-align: left;
  font-family: "Times New Roman", Times, serif;
}
.li-center-title{
  font-size: 0.1125rem;
  color: #365b3a;
  font-weight: 600;
  text-align: left;
  letter-spacing: 2px;
  line-height: 1;
  margin-bottom: 0.1375rem;
  font-family: "Times New Roman", Times, serif;
}
.li-center-font{
  font-size: 0.0935rem;
  color: #5a625a;
  line-height: 1.6;
  text-align: left;
  font-family: "Times New Roman", Times, serif;
}
.index-foot-bottom{
  width: 100%;
  height: auto;
  margin-top: 0.25rem;
  padding-bottom: 0.375rem;
}
.foot-bottom-btn{
  width: 1rem;
  height: 0.25rem;
  border: 1px solid #365b3a;
  border-radius: 0.25rem;
  color: #365b3a;
  font-size: 0.1125rem;
  line-height: 0.25rem;
  font-family: "Times New Roman", Times, serif;
  cursor: pointer;
}
.index-foot-bottomPhone{
  width: 100%;
  height: auto;
  padding-top: 0.25rem;
}

/**  首页  新闻 phone  **/
.phone-index-foot{
  padding: 0.8rem 0.2rem 0.6rem;
  height: auto;
  background: #f5f8ef;
}
.index-foot-titlePhone{
  font-size: 0.52rem;
  color: #365b3a;
  text-align: center;
  line-height: 1;
  margin-bottom: 0.25rem;
}
.foot-center-liPhone{
  width: 48%;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-bottom: 0.32rem;
}
.foot-bottom-btnPhone{
  width: 2.6rem;
  height: 0.6rem;
  border: 1px solid #365b3a;
  border-radius: 0.6rem;
  color: #365b3a;
  font-size: 0.32rem;
  line-height: 0.6rem;
  font-family: "Times New Roman", Times, serif;
}

.phone-center-list{
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  font-size: 0.36rem;
  color: #fff;
  line-height: 1.4;
  letter-spacing: 2px;
  background: rgba(220,155,97,0.95);
  position: relative;
}

/** web 图 **/
.partner-center{
  padding: 0.625rem 0.5rem 0.375rem;
  height: auto;
  background: #f5f8ef;
}
.partner-center-middle{
  padding: 0.1125rem;
  height: auto;
  background: #fff;
  border-radius: 6px;
}
.center-middle-left{
  width: 32%;
  margin-right: 0.1125rem;
  height: auto;
}
.middle-left-img{
  width: 100%;
  height: 3.9875rem;
  max-height: 3.9875rem;
  display: inline-block;
}
.middle-left-font{
  font-size: 0.1125rem;
  color: #365b3a;
  line-height: 1;
  margin-top: 0.08rem;
  text-align: left;
}
.center-middle-right{
  flex: 2;
  height: auto;
}

/** phone 图 **/
.phone-partner-center{
  padding: 0.75rem 0.5rem;
  height: auto;
  background: #f5f8ef;
}
.phoneCenter-middle-list{
  width: 100%;
  height: auto;
  line-height: 1;
  margin-top: 0.6rem;
}
.phoneMiddle-left-img{
  width: 100%;
  height: auto;
  display: inline-block;
}
.phoneMiddle-left-font{
  font-size: 0.34rem;
  color: #365b3a;
  margin-top: 0.2rem;
  text-align: left;
}

/** web 轮播图 **/
.partner-middle{
  padding: 0 0.5rem 0.375rem;
  height: auto;
  background: #f5f8ef;
}
.index-foot-title{
  font-size: 0.3rem;
  color: #365b3a;
  text-align: center;
  line-height: 1;
  margin-bottom: 0.25rem;
  font-family:'huangyou';
}
.partner-middle-center{
  width: 100%;
  height: 2.45rem;
  padding-top: 0.25rem;
  position: relative;
}
.swiper-slide-img{
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.swiper-slide>.swiper-slide-center{
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
  position: relative;
}
.swiper-slide-active>.swiper-slide-center,.swiper-slide-duplicate-active>.swiper-slide-center{
  transform: scale(1.2);
}
.slide-center-middle{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(54,91,58,0.8);
  border-radius: 0 0 8px 8px;
  height: 0.41rem;

}
.center-middle-title{
  padding: 0 0.1125rem;
  height: 0.41rem;
  font-size: 0.1125rem;
  color: #fff;
  text-align: left;
  line-height: 0.41rem;
}
.middle-center-img{
  width: 0.3625rem;
  height: auto;
  position: absolute;
  z-index: 999;
  cursor: pointer;
}
.center-img-left{
  left: 0.125rem;
  top: 50%;
  transform: translateY(-50%);
}
.center-img-right{
  right: 0.125rem;
  top: 50%;
  transform: translateY(-50%);
}

/** phone 轮播图 **/
.phone-partner-middle{
  padding: 0.75rem 0.5rem;
  height: auto;
  background: #f5f8ef;
}
.index-foot-titlePhone{
  font-size: 0.52rem;
  color: #365b3a;
  text-align: center;
  line-height: 1;
  margin-bottom: 0.25rem;
}
.partner-middle-centerPhone,.swiper-slide-imgPhone{
  width: 100%;
  height: auto;
  overflow: hidden;
}
.swiper-slide-centerPhone{
  width: 100%;
  height: auto;
  position: relative;
}
.slide-center-middlePhone{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(54,91,58,0.8);
  border-radius: 0 0 8px 8px;
  height: 1rem;
}
.center-middle-titlePhone{
  padding: 0 0.28rem;
  font-size: 0.34rem;
  color: #fff;
  
}

/** web 合作伙伴 **/
.partner-footer{
  padding: 0 0.5rem 0.375rem;
  height: auto;
  background: #f5f8ef;
}
.partner-footer-center{
  width: 100%;
  height: auto;
}
.partner-footer-center::after{
  content: "";
  display: block;
  clear: both;
}
.footer-center-list{
  width: 23.5%;
  height: auto;
  background: #fff;
  margin-right: 2%;
  margin-bottom: 2%;
  float: left;
}
.footer-center-list:nth-child(4n){
  margin-right: 0;
}
.center-list-img{
  width: 100%;
  height: auto;
}

/** phone 合作伙伴 **/
.phone-partner-footer{
  padding: 0.75rem 0.5rem;
  height: auto;
  background: #f5f8ef;
}
.phone-footer-center{
  width: 100%;
  height: auto;
}
.footer-center-listPhone{
  width: 48%;
  height: auto;
  margin-bottom: 2%;
  background: #fff;
}
.phone-list-img{
  width: 100%;
  height: auto;
}

</style>

